var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimpleFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 2048 2048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E7F5"
    },
    d: "M1355.572,256H475.766c-22.804,0-41.29,18.486-41.29,41.29V1750.71 c0,22.804,18.486,41.29,41.29,41.29h1096.469c22.804,0,41.29-18.486,41.29-41.29V513.93h-0.011L1355.572,256"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B0CCDD"
    },
    points: "1355.573,256 1355.573,513.935 1613.518,513.935  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72B8CE"
    },
    d: "M797.119,1294.912c-89.623,0-162.281-72.657-162.281-162.288c0-44.815,18.168-85.383,47.529-114.752 c29.368-29.368,69.944-47.529,114.752-47.529h9.625c0-119.99,97.266-217.255,217.255-217.255s217.255,97.266,217.255,217.255h9.625 c89.623,0,162.281,72.65,162.281,162.281c0,44.815-18.168,85.383-47.529,114.759c-29.368,29.361-69.944,47.529-114.752,47.529 H797.119z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleFile);
export default __webpack_public_path__ + "static/media/simpleFile.997d511d7bc96d24c15837b61b9f9440.svg";
export { ForwardRef as ReactComponent };